/* Frost bestsellers — arrow + dot slider. Same mechanics as
   frost-gifting.js: one scroll position per card, arrows fully hidden
   (via the "no-overflow" toggle on the wrap) once every card already fits
   on screen instead of just fading/disabling. */
(function () {
  function initFrostBsSlider(section) {
    var wrap = section.querySelector('[data-frost-bs-wrap]');
    var track = section.querySelector('[data-frost-bs-track]');
    var slides = Array.prototype.slice.call(section.querySelectorAll('[data-frost-bs-slide]'));
    var prevBtn = section.querySelector('[data-frost-bs-prev]');
    var nextBtn = section.querySelector('[data-frost-bs-next]');
    var pagination = section.querySelector('[data-frost-bs-pagination]');

    if (!track || !slides.length) return;

    var visibleCount = 1;
    var totalPositions = 1;
    var currentIndex = 0;
    var dots = [];

    function getVisibleCount() {
      var w = window.innerWidth;
      if (w <= 989) return 2;
      return parseInt(getComputedStyle(section).getPropertyValue('--frost-bs-columns')) || 4;
    }

    function getStep() {
      var slide = slides[0];
      var style = getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap || 0);
      return slide.getBoundingClientRect().width + gap;
    }

    function buildDots() {
      if (!pagination) return;
      pagination.innerHTML = '';
      dots = [];
      if (totalPositions <= 1) {
        pagination.classList.add('is-hidden');
        return;
      }
      pagination.classList.remove('is-hidden');
      for (var i = 0; i < totalPositions; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'frost-bs__page-dot';
        dot.setAttribute('aria-label', 'Go to card ' + (i + 1));
        (function (index) {
          dot.addEventListener('click', function () {
            goToIndex(index);
          });
        })(i);
        pagination.appendChild(dot);
        dots.push(dot);
      }
      updateDots();
    }

    function updateDots() {
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === currentIndex);
      });
    }

    function goToIndex(index) {
      index = Math.max(0, Math.min(index, totalPositions - 1));
      currentIndex = index;
      var step = getStep();
      track.scrollTo({ left: step * index, behavior: 'smooth' });
      updateDots();
    }

    function recalc() {
      visibleCount = getVisibleCount();
      totalPositions = Math.max(1, slides.length - visibleCount + 1);
      currentIndex = Math.min(currentIndex, totalPositions - 1);
      if (wrap) wrap.classList.toggle('frost-bs__slider-wrap--no-overflow', totalPositions <= 1);
      buildDots();
    }

    var scrollTimeout;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function () {
        var step = getStep();
        if (!step) return;
        var index = Math.round(track.scrollLeft / step);
        currentIndex = Math.max(0, Math.min(index, totalPositions - 1));
        updateDots();
      }, 100);
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goToIndex(currentIndex - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goToIndex(currentIndex + 1);
      });
    }

    var resizeTimeout;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(recalc, 150);
    });

    recalc();
  }

  document.querySelectorAll('[data-frost-bs-section]').forEach(initFrostBsSlider);
})();
